import { render } from "./CompanyFeedbackDataTable.vue?vue&type=template&id=0f063636&scoped=true"
import script from "./CompanyFeedbackDataTable.vue?vue&type=script&lang=js"
export * from "./CompanyFeedbackDataTable.vue?vue&type=script&lang=js"

import "./CompanyFeedbackDataTable.vue?vue&type=style&index=0&id=0f063636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f063636"]])

export default __exports__